<template>
  <div class="instant-play-cell">
    <a role="button" @click.prevent="() => $emit('on-click-thumbnail', cell)">
      <div ref="cellImgList" :class="['cell-img', { adult: isAdult }]">
        <div v-if="isAutoPlayCell" class="play-button">
          <span class="a11y-hidden">재생하기</span>
        </div>
        <img v-lazy="thumbnailImage" :src="thumbnailImage" :alt="altTitle" />
        <AgeTag v-if="hasAgeTag" key="age_tag" :age-code="ageTag" />
        <BadgeList
          v-if="hasBrandList"
          :key="`${brandTag}__tag`"
          :badge-list="brandTagList"
          type="brand"
        />
      </div>
    </a>

    <div class="cell-info">
      <div class="title-box">
        <p class="view-title">
          <span>{{ title }}</span>
        </p>
      </div>
      <div v-if="isAutoPlayCell" class="icon-wrap">
        <IconBoxZzimWithEvent
          key="button_like_it"
          :event-list="eventList"
          is-zzim-title="y"
          :zzim="isZzim"
        />
        <a
          v-if="isOriginalId && !isComingSoon"
          role="button"
          class="icon-box"
          @click.prevent="$emit('on-click-icon', cell)"
        >
          <IconMainMovie key="button_go_to_main_content" />
          <span class="icon-txt">본편 보기</span>
        </a>
      </div>

      <div class="desc-box">
        <span v-if="isComingSoon" class="comingsoon-release-date">
          {{ comingSoonReleaseDate }}
        </span>
        <strong v-if="description !== ''" class="comment">{{
          description
        }}</strong>
        <p v-if="synopsis !== ''" class="preview" v-html="synopsis" />

        <div v-if="hasActor" class="cast">
          <table>
            <caption>
              출연표
            </caption>
            <colgroup>
              <col style="width: 34px" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th>출연:&nbsp;</th>
                <td>
                  <div>
                    <span>{{ actors }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
  import { computed, defineProps, defineEmits } from 'vue'
  import { resizeThumbnail } from '@/common/image.filter'
  import { getTitle } from '@/common/util/common'
  import { useRoute } from 'vue-router/composables'
  import utils from '@/common/util/utils'
  import { COOKIE_KEY_VERIFIED_ADULT } from '@/common/constant'
  import AgeTag from '@/components/tags/AgeTag.vue'
  import BadgeList from '@/components/tags/BadgeList.vue'
  import IconMainMovie from '@/assets/svg/common/icon-main-movie.svg'
  import IconBoxZzimWithEvent from '@/components/play/IconBoxZzimWithEvent.vue'

  const props = defineProps({
    cell: {
      type: Object,
      required: true,
      default: null,
    },
    thumbnailInfo: {
      type: Object,
      required: true,
      default: null,
    },
  })

  defineEmits(['on-click-thumbnail', 'on-click-icon'])

  const route = useRoute()

  const actors = computed(() => props.cell?.actors ?? '')
  const ageTag = computed(() => props.cell?.age_tag ?? '')
  const altTitle = computed(() => getTitle(props.cell))
  const brandTagList = computed(() => props.cell?.brand_taglist ?? [])
  const brandTag = computed(() => brandTagList.value[0] ?? '')
  const comingSoonReleaseDate = computed(
    () => props.cell?.commingSoonReleaseDate ?? '',
  )
  const description = computed(() => props.cell?.description ?? '')
  const eventList = computed(() => props.cell?.event_list ?? [])
  const hasActor = computed(() => actors.value !== '')
  const hasAgeTag = computed(() => ageTag.value !== '')
  const hasBrandList = computed(
    () => brandTagList.value.length > 0 && brandTag.value !== '',
  )
  const isAdult = computed(
    () =>
      Number(props.cell?.age) >= 21 &&
      (utils.cookies.getCredential() === 'none' ||
        utils.cookies.getItem(COOKIE_KEY_VERIFIED_ADULT) !== '1'),
  )
  const isAutoPlayCell = computed(() => eventList.value.length > 0)
  const isComingSoon = computed(() => props.cell?.is_coming_soon === 'y')
  const isOriginalId = computed(() => props.cell?.is_original_id !== '')
  const isZzim = computed(() => props.cell?.iszzim?.toLowerCase() ?? 'n')
  const title = computed(() => props.cell?.title_list?.[0]?.text ?? '')
  const synopsis = computed(() => props.cell?.synopsis ?? '')

  const thumbnailImage = computed(() =>
    resizeThumbnail(props.cell?.thumbnail, props.thumbnailInfo),
  )
</script>
